import React, { Component } from 'react'
import Link from '../utils/link'
import { navigate } from 'gatsby'

class RAForm extends Component {

  state = {
    form: {
      key: 'Hisoi87hsd87g',
      accountName: 'whitefox',
      referrer: {
        firstName: 'Zac',
        lastName: 'Muller',
        phone: '',
        email: 'zac@whitefoxrealestate.com.au',
        mobile: '0497 888 262',
        comments: '',
        companyName: 'Whitefox Realestate'
      },
      property: {
        streetNo: '',
        street: '',
        suburb: '',
        state: '',
        postcode: '',
        bedrooms: 0,
        bathrooms: 0,
        garages: 0,
        carports: 0,
        description: '',
      },
      contact: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        mobile: '',
        comments: ''
      },
    },
    step1: true,
    step2: false,
    success: false,
    msg: '',
    loading: false
  }

  proceed = e => {
    e.preventDefault()
    if (!this.refs.form.checkValidity()) return false
    this.setState({
      step1: false,
      step2: true
    })
    document && document.querySelector('.property-management-form__inner').scrollIntoView({ 
      behavior: 'smooth' 
    })
  }

  handleContactChange = e => {
    let { form } = this.state
    form['contact'][e.target.name] = e.target.value
    this.setState({ form })
  }

  handlePropertyChange = e => {
    let { form } = this.state
    form['property'][e.target.name] = e.target.value
    this.setState({ form })
  }

  handleSubmit = e => {
    e.preventDefault()

    let { form } = this.state

    this.setState({ loading: true })
    fetch("https://whitefox.codedrips.com/wp-json/appraisal/v1/rental", {
      method: "POST",
      headers: {
        "Content-Type": "application/json" 
      },
      body: JSON.stringify(form)
    })
    .then((response) => {
      this.setState({
        success: true,
        loading: false
      })
      document && document.querySelector('.property-management-form__inner').scrollIntoView({ 
        behavior: 'smooth' 
      });
    })
    .catch((error) => {
      this.setState({ 
        loading: false, 
        msg: error
      })
    })

  }

  render() {
    const data = this.props
    let { step1, step2, success, loading } = this.state

    let props = {
      ref: 'form',
      name: 'rental_appraisal'
    }

    if (success) {

      navigate('/thank-you');
      return (
        <section className='property-management-form rental-appraisal' data-color='#64656A'>
          <div className='property-management-form__inner'>
            <h4 className='intro'>Thank you your enquiry has now been submitted. </h4>
            <p className='intro'>One of our helpful team will be in touch with you soon to discuss your enquiry.</p>
            <p className='intro'><Link to='/contact/' className='btn'>Book Appraisal</Link></p>
          </div>
        </section>
      )
    }

    return (
      <section className='property-management-form rental-appraisal' data-color='#64656A'>
        <div className='property-management-form__inner'>
          <form {...props}>
            <div className={`form__step ${step1 ? 'active' : ''}`}>
              <h4>Thank you for your interest in our services!</h4>
              <p>Please provide your contact details below.</p>
              <div className='form__row form__row--double'>
                <input type='text' name='firstName' placeholder='First Name' onChange={this.handleContactChange} required />
                <input type='text' name='lastName' placeholder='Last Name' onChange={this.handleContactChange} required />
              </div>
              <div className='form__row form__row--double'>
                <input type='text' name='mobile' placeholder='Mobile Number' onChange={this.handleContactChange} required />
                <input type='text' name='phone' placeholder='Phone Number' onChange={this.handleContactChange} />
              </div>
              <div className='form__row'>
                <input type='email' name='email' placeholder='Email' onChange={this.handleContactChange} required />
              </div>
              <div className='form__row'>
                <textarea row='6' placeholder='How can we help?' name='comments' onChange={this.handleContactChange} />
              </div>
              <button className='contactbtn' onClick={this.proceed}>Proceed</button>
            </div>
            <div className={`form__step ${step2 ? 'active' : ''}`}>
              <p>To aid us in assisting with this enquiry, please take a moment to complete the additional details below (if applicable):</p>
              <div className='form__row form__row--address'>
                <input type='text' name='streetNo' placeholder='Unit & Street No' onChange={this.handlePropertyChange}  />
                <input type='text' name='street' placeholder='Street' onChange={this.handlePropertyChange} />
              </div>
              <div className='form__row form__row--suburb'>
                <input type='text' name='suburb' placeholder='Suburb' onChange={this.handlePropertyChange} />
                <input type='text' name='postcode' placeholder='Postcode' onChange={this.handlePropertyChange} />
                <input type='text' name='state' placeholder='State' onChange={this.handlePropertyChange} />
              </div>
              <div className='form__row form__row--selects'>
                <select name='bedrooms' onChange={this.handlePropertyChange}>
                  <option>Bedrooms</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                </select>
                <select name='bathrooms' onChange={this.handlePropertyChange}>
                  <option>Bathrooms</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                </select>
                <select name='garages' onChange={this.handlePropertyChange}>
                  <option>Garages</option>
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                </select>
                <select name='carports' onChange={this.handlePropertyChange}>
                  <option>Carports</option>
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                </select>
              </div>
              <div className='form__row'>
                <textarea name='description' placeholder='Property Description' onChange={this.handlePropertyChange} />
              </div>
              <button className='contactbtn' type='button' onClick={(e) => this.handleSubmit(e)}>
                Submit 
                { loading && 
                  <span className="lds-ripple">
                    <span></span>
                    <span></span>
                  </span> 
                }
              </button>
            </div>
            <div className='rental-appraisal__footnote' dangerouslySetInnerHTML={{ __html: data.footNote }} />
          </form>
        </div>
      </section>
    )
  }
}

export default RAForm
